export const SiteURLs = {
  CUSTOMER_STORIES: '/resources/automation-case-studies',
  RESOURCE_CENTER: '/resources/all',
  RESOURCE_CENTER_AR: '/resources/automation-analyst-reports',
  RESOURCE_CENTER_CASE_STUDIES: '/resources/automation-case-studies',
  RESOURCE_CENTER_WEBINARS: '/resources/automation-webinars',
  RESOURCE_CENTER_WP: '/resources/automation-whitepapers',
  RESOURCE_CENTER_BROCHURES: '/resources/automation-brochures',
  RESOURCE_CENTER_VIDEOS: '/resources/automation-demo',
  RESOURCE_CENTER_EVENTS: '/events',
}
